export default __webpack_public_path__ + "static/memoji-b7f6644db187517e4ea4e001d73a2b71.png";